import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesStoreGmb = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadingForUpdate: false,
    loadError: false,
    connected: false,
  },
  mutations: {
    readStoreGmb(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    readStoreGmbSuccess(state, payload) {
      state.data = payload.data
      // 読み込み時の状態を保持のため
      state.connected = !!state.data?.attributes?.location
      state.loading = false
      state.loadError = false
    },
    readStoreGmbFailure(state) {
      state.loading = false
      state.loadError = true
    },
    updateStoreGmb(state) {
      state.loading = true
    },
    updateStoreGmbSuccess(state) {
      state.loading = false
    },
    updateStoreGmbFailure(state) {
      state.loading = false
    },
    updateGmbSynced(state) {
      state.loadingForUpdate = true
    },
    updateGmbSyncedSuccess(state) {
      state.loadingForUpdate = false
    },
    updateGmbSyncedGmbFailure(state) {
      state.loadingForUpdate = false
    },
    changeSyncedAll(state, value) {
      state.data.attributes.name_synced = value
      state.data.attributes.description_synced = value
      state.data.attributes.website_url_synced = value
      state.data.attributes.address_synced = value
      state.data.attributes.phone_synced = value
      state.data.attributes.payment_method_synced = value
      state.data.attributes.business_hours_synced = value
      state.data.attributes.category_synced = value
      state.data.attributes.open_info_synced = value
    },
    resetLocation(state) {
      if (!state.data) return

      state.data.attributes.location = null
    },
    setConnected(state, value) {
      state.connected = value
    },
    changeIndividualSynced(state, {syncedKey, value}) {
      state.data.attributes[syncedKey] = value
    }
  },
  getters: {
    gmbLocationSynced: (state) => {
      const attributes = state.data?.attributes
      return {
        name_synced: attributes?.name_synced,
        description_synced: attributes?.description_synced,
        website_url_synced: attributes?.website_url_synced,
        address_synced: attributes?.address_synced,
        phone_synced: attributes?.phone_synced,
        payment_method_synced: attributes?.payment_method_synced,
        business_hours_synced: attributes?.business_hours_synced,
        category_synced: attributes?.category_synced,
        open_info_synced: attributes?.open_info_synced
      }
    },
    syncedAll: (_, getters) => {
      const synced = getters.gmbLocationSynced
      return (synced.name_synced &&
              synced.description_synced &&
              synced.website_url_synced &&
              synced.address_synced &&
              synced.phone_synced &&
              synced.payment_method_synced &&
              synced.business_hours_synced &&
              synced.category_synced &&
              synced.open_info_synced)
    },
    queryForUpdate: (_, getters) => {
      return {
        store_gmb: getters.gmbLocationSynced
      }
    },
    hasGmbLocation: (state) => {
      return !!state.data?.attributes?.location
    },
    storeName: (state) => {
      return state.data ? state.data.attributes.store_name : ''
    }
  },
  actions: {
    async readStoreGmb({ commit }, { company_uuid, store_uuid }) {
      commit('readStoreGmb')
      return axios
        .get('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/gmb.json')
        .then(res => {
          commit('readStoreGmbSuccess', res.data)
          return res.data
        })
        .catch(err => {
          commit('readStoreGmbFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    async createStoreGmb({ commit, state }, {company_uuid, store_uuid, payload}) {
      // errorsの有無で店舗情報の再取得をハンドリングしているため、ここでもerrorsを返す。
      if (state.loading) return { errors: '' }

      commit('flash/clearFlash', null, { root: true })
      commit('updateStoreGmb')
      return axios
        .post('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/gmb.json', payload)
        .then(() => {
          commit('updateStoreGmbSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.storeGmbLocation.modelName') }) }, { root: true })
        })
        .catch(err => {
          const errors = err?.response?.data?.errors
          commit('updateStoreGmbFailure')
          commit('flash/updateFlash', { type: 'alert', message: errors ? errors[0].detail : i18n.t('messages.failedDataLinkage') }, { root: true })
          console.error(err)
          return { errors: err }
        })
    },

    async updateStoreGmb({ commit, state, getters }, {company_uuid, store_uuid}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('updateGmbSynced')
      return axios
        .put('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/gmb.json', getters.queryForUpdate)
        .then(() => {
          commit('updateGmbSyncedSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('labels.setting') }) }, { root: true })
        })
        .catch(err => {
          const errors = err?.response?.data?.errors
          commit('updateGmbSyncedGmbFailure')
          commit('flash/updateFlash', { type: 'alert', message: errors ? errors[0].detail : i18n.t('messages.tryLater') }, { root: true })
          console.error(err)
        })
    },

    async deleteStoreGmb({ commit, state }, {company_uuid, store_uuid}) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      return axios
        .delete('/api/companies/' + company_uuid + '/stores/' + store_uuid + '/gmb.json')
        .then(() => {
          commit('setConnected', false)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('models.locationConnect.deleted') }, { root: true })
        })
        .catch(err => {
          const errors = err?.response?.data?.errors
          commit('flash/updateFlash', { type: 'alert', message: errors ? errors[0].detail : i18n.t('messages.tryLater') }, { root: true })
          console.error(err)
        })
    },

    changeSyncedAll({ commit }, value) {
      commit('changeSyncedAll', value)
    },

    resetLocation({ commit }) {
      commit('resetLocation')
    },
    // Googleによる変更防止を個別に設定する
    updateGmbLocationSyncedParam({ commit }, payload) {
      const { syncedKey , value } = payload
      commit('changeIndividualSynced', { syncedKey, value })
    },
  },
}
